import React from "react";
//import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
// import history from "../store/history";
import { getAccessToken } from "../utils/storage";

export default function LoginRoute({ component: Component, ...rest }) {
  //const isLoggedIn = useSelector(state => !!state.auth.accessToken);
  const isLoggedIn = !!getAccessToken();

  // const prevPath =
  //   !!history.location.state && history.location.state.from.pathname;
  //console.log(prevPath);
  return (
    <Route
      {...rest}
      component={props =>
        isLoggedIn ? (
          // prevPath ? (
          //   <Redirect to={prevPath} />
          // ) : (
          <Redirect to="/dashboard" />
          // )
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}
